import { BadgeCheck, ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export const Verified = ({ on }) => (on
  ? <span className="inline-flex items-center gap-1 text-xs text-green-700"><BadgeCheck className="h-3.5 w-3.5" /> Vérifié</span>
  : <span className="text-xs text-stone-400">Non vérifié</span>);

export const DirectoryList = ({ data, page, setPage, onOpen }) => {
  if (!data) return <p className="text-sm text-stone-500" data-testid="directory-loading">Chargement…</p>;
  const pages = Math.max(1, Math.ceil(data.total / data.limit));
  return (
    <div className="space-y-3">
      <div className="bg-white border border-stone-200 rounded-lg divide-y divide-stone-100" data-testid="directory-list">
        {data.items.length === 0 && <p className="p-8 text-center text-sm text-stone-500" data-testid="directory-empty">Aucune fiche ne correspond.</p>}
        {data.items.map((d) => (
          <button key={d.id} type="button" onClick={() => onOpen(d)} data-testid={`directory-row-${d.id}`}
            className="w-full text-left px-4 py-3 grid sm:grid-cols-[1fr_220px_110px] gap-x-4 gap-y-1 hover:bg-stone-50 transition-colors duration-150">
            <div className="min-w-0">
              <p className="font-medium text-stone-900 truncate">{d.name}{d.name_ar && d.name_ar !== d.name && <span className="ml-2 text-stone-500 font-normal tracking-normal" dir="rtl" lang="ar">{d.name_ar}</span>}</p>
              <p className="text-xs text-stone-500 truncate">{d.subcategory}{d.address ? ` · ${d.address}` : ""}</p>
            </div>
            <p className="text-sm text-stone-600 truncate">{d.phone || "—"}</p>
            <div className="flex sm:justify-end items-center gap-2">{d.source === "sehatic-gestion" && <span className="text-[10px] uppercase tracking-wider text-[#C2410C]">Ajout</span>}<Verified on={d.verified} /></div>
          </button>
        ))}
      </div>
      <div className="flex items-center justify-end gap-2 text-sm text-stone-600">
        <span data-testid="directory-page-info">Page {page} / {pages}</span>
        <Button variant="outline" size="sm" disabled={page <= 1} onClick={() => setPage(page - 1)} data-testid="directory-prev"><ChevronLeft className="h-4 w-4" /></Button>
        <Button variant="outline" size="sm" disabled={page >= pages} onClick={() => setPage(page + 1)} data-testid="directory-next"><ChevronRight className="h-4 w-4" /></Button>
      </div>
    </div>
  );
};
